/* eslint-disable camelcase,no-param-reassign,@typescript-eslint/no-shadow,@typescript-eslint/no-unused-vars,prefer-destructuring */

import { EVENTS } from '../../../../app/constants/events';

const REPORT_DATE_RANGE_TYPES = [
  {
    value: 'TODAY',
    text: 'bing-ads-source-editor.form.selects.report_aggregation_type.options.today',
    translate: true,
    unsuportedAggregationTypes: 'MONTHLY WEEKLY YEARLY',
  },
  {
    value: 'YESTERDAY',
    text: 'bing-ads-source-editor.form.selects.report_aggregation_type.options.yesterday',
    translate: true,
    unsuportedAggregationTypes: 'MONTHLY WEEKLY YEARLY',
  },
  {
    value: 'LAST_SEVEN_DAYS',
    text: 'bing-ads-source-editor.form.selects.report_aggregation_type.options.last_seven_days',
    translate: true,
    unsuportedAggregationTypes: 'HOURLY MONTHLY WEEKLY YEARLY',
  },
  {
    value: 'THIS_WEEK',
    text: 'bing-ads-source-editor.form.selects.report_aggregation_type.options.this_week',
    translate: true,
    unsuportedAggregationTypes: 'SUMMARY HOURLY DAILY MONTHLY YEARLY HOUR_OF_DAY DAY_OF_WEEK',
  },
  {
    value: 'LAST_WEEK',
    text: 'bing-ads-source-editor.form.selects.report_aggregation_type.options.last_week',
    translate: true,
    unsuportedAggregationTypes: 'SUMMARY HOURLY DAILY MONTHLY YEARLY HOUR_OF_DAY DAY_OF_WEEK',
  },
  {
    value: 'LAST_FOUR_WEEKS',
    text: 'bing-ads-source-editor.form.selects.report_aggregation_type.options.last_four_weeks',
    translate: true,
    unsuportedAggregationTypes: 'SUMMARY HOURLY DAILY MONTHLY YEARLY HOUR_OF_DAY DAY_OF_WEEK',
  },
  {
    value: 'THIS_MONTH',
    text: 'bing-ads-source-editor.form.selects.report_aggregation_type.options.this_month',
    translate: true,
    unsuportedAggregationTypes: 'HOURLY YEARLY',
  },
  {
    value: 'LAST_MONTH',
    text: 'bing-ads-source-editor.form.selects.report_aggregation_type.options.last_month',
    translate: true,
    unsuportedAggregationTypes: 'HOURLY YEARLY',
  },
  {
    value: 'LAST_THREE_MONTHS',
    text: 'bing-ads-source-editor.form.selects.report_aggregation_type.options.last_three_months',
    translate: true,
    unsuportedAggregationTypes: 'DAILY HOURLY WEEKLY YEARLY SUMMARY',
  },
  {
    value: 'LAST_SIX_MONTHS',
    text: 'bing-ads-source-editor.form.selects.report_aggregation_type.options.last_six_months',
    translate: true,
    unsuportedAggregationTypes: 'DAILY HOURLY WEEKLY YEARLY SUMMARY',
  },
  {
    value: 'THIS_YEAR',
    text: 'bing-ads-source-editor.form.selects.report_aggregation_type.options.this_year',
    translate: true,
    unsuportedAggregationTypes: 'SUMMARY HOURLY DAILY HOUR_OF_DAY DAY_OF_WEEK',
  },
  {
    value: 'LAST_YEAR',
    text: 'bing-ads-source-editor.form.selects.report_aggregation_type.options.last_year',
    translate: true,
    unsuportedAggregationTypes: 'SUMMARY HOURLY DAILY HOUR_OF_DAY DAY_OF_WEEK',
  },
  {
    value: 'CUSTOM_DATE',
    text: 'bing-ads-source-editor.form.selects.report_aggregation_type.options.custom_date',
    translate: true,
    unsuportedAggregationTypes: 'DAY_OF_WEEK HOUR_OF_DAY',
  },
];

xplenty.directive('bingAdsSourceEditor', [
  '$rootScope',
  'AuthService',
  function ($rootScope, AuthService) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./bing-ads-source-editor.html'),

      replace: true,

      controller: [
        '$scope',
        '$stateParams',
        '$http',
        function ($scope, $stateParams, $http) {
          const url = `${process.env.API_URL}/${$stateParams.account_id}/api/connections/metadata/bingads/columns?report_type=`;

          $scope.loadingReportTypeFields = false;
          $scope.fieldsLoadError = false;

          $scope.reportTypes = [];

          $scope.apiVersionOptions = [
            {
              text: 'v13',
              value: 'v13',
            },
          ];

          $scope.reportDateRangeTypes = REPORT_DATE_RANGE_TYPES;

          $scope.reportAggregationTypes = [
            {
              value: 'SUMMARY',
              text: 'bing-ads-source-editor.form.selects.report_date_range_type.options.summary',
              translate: true,
            },
            {
              value: 'HOURLY',
              text: 'bing-ads-source-editor.form.selects.report_date_range_type.options.hourly',
              translate: true,
            },
            {
              value: 'DAILY',
              text: 'bing-ads-source-editor.form.selects.report_date_range_type.options.daily',
              translate: true,
            },
            {
              value: 'WEEKLY',
              text: 'bing-ads-source-editor.form.selects.report_date_range_type.options.weekly',
              translate: true,
            },
            {
              value: 'MONTHLY',
              text: 'bing-ads-source-editor.form.selects.report_date_range_type.options.monthly',
              translate: true,
            },
            {
              value: 'YEARLY',
              text: 'bing-ads-source-editor.form.selects.report_date_range_type.options.yearly',
              translate: true,
            },
            {
              value: 'HOUR_OF_DAY',
              text: 'bing-ads-source-editor.form.selects.report_date_range_type.options.hour_of_day',
              translate: true,
            },
            {
              value: 'DAY_OF_WEEK',
              text: 'bing-ads-source-editor.form.selects.report_date_range_type.options.day_of_week',
              translate: true,
            },
          ];

          $scope.onApiVersionChange = function (apiVersion) {
            $scope.component.api_version = apiVersion;
          };

          $scope.onReportAggregateChange = function (reportAggregate) {
            $scope.component.report_aggregation_type = reportAggregate;

            let dateRangeNonExistent = false;

            $scope.reportDateRangeTypes = REPORT_DATE_RANGE_TYPES.map((reportDateRangeType) => {
              if (
                reportDateRangeType.unsuportedAggregationTypes.indexOf($scope.component.report_aggregation_type) === -1
              ) {
                return {
                  text: reportDateRangeType.text,
                  value: reportDateRangeType.value,
                  translate: true,
                };
              }

              if ($scope.component.report_date_range_type === reportDateRangeType.value) {
                dateRangeNonExistent = true;
              }
              return null;
            }).filter(Boolean);

            if (dateRangeNonExistent) {
              $scope.component.report_date_range_type = $scope.reportDateRangeTypes[0].value;
            }

            $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_SET_META_DATA_FIELDS);
          };

          $scope.onReportDateRangeChange = function (reportDateRange) {
            window.use_custom_date_range = reportDateRange === 'CUSTOM_DATE';

            $scope.component.report_date_range_type = reportDateRange;

            const existingDateField = $scope.selectedFields.find((item) => item.name === 'time_period_date');
            if (existingDateField) {
              existingDateField.markedToBeRemoved = true;
              $scope.component.time_period_date_field_alias = null;
            }
            const existingHourField = $scope.selectedFields.find((item) => item.name === 'time_period_hour');
            if (existingHourField) {
              existingHourField.markedToBeRemoved = true;
              $scope.component.time_period_hour_field_alias = null;
            }
          };

          $scope.onReportTypeChange = function (reportType) {
            $scope.component.report_type = reportType;
            $scope.refreshReportType(reportType);
          };

          $scope.onAccountsCampaignsChange = function (accountsCampaigns) {
            $scope.component.accounts_campaigns = accountsCampaigns;
          };

          $scope.getReportTypes = function () {
            if ($scope.component.api_version) {
              $http({
                headers: {
                  Authorization: `Bearer ${AuthService.getToken()}`,
                },
                url: `${process.env.API_URL}/bingads/${$scope.component.api_version}.json`,
                method: 'GET',
              }).then(function (res) {
                $scope.reportTypes = res.data.map(({ name, title }) => ({ text: title, value: name }));
              });
            }
          };

          $scope.$watch('component.api_version', $scope.getReportTypes);

          $scope.refreshReportType = function (report_type) {
            if (!report_type) return;

            $scope.loadingReportTypeFields = true;
            $scope.fieldsLoadError = false;

            $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_LOADING_STARTED);
            $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_SET_AVAILABLE_FIELDS, []);

            $http({
              headers: {
                Authorization: `Bearer ${AuthService.getToken()}`,
              },
              method: 'GET',
              url: `${url + report_type}&api_version=${$scope.component.api_version}`,
            }).then(
              function (response) {
                const fields = [];
                _.each(response.data.fields, function (field) {
                  const name = Object.keys(field)[0];
                  const data_type = field[name];
                  fields.push({
                    name,
                    alias: name,
                    data_type,
                    category: 'Report',
                  });
                });
                const timePeriodFieldIndex = _.findIndex(fields, { name: 'TIME_PERIOD' });
                if (timePeriodFieldIndex > -1) {
                  $scope.component.hasTimePeriodField = true;
                  fields.splice(timePeriodFieldIndex, 1);
                } else {
                  $scope.component.hasTimePeriodField = false;
                }
                $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_SET_AVAILABLE_FIELDS, fields);
                $scope.loadingReportTypeFields = false;
                $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_LOADING_ENDED);
              },
              function () {
                $scope.fieldsLoadError = true;
                $scope.loadingReportTypeFields = false;
                $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_LOADING_ENDED);
              },
            );
          };

          $scope.refreshReportType($scope.component.report_type);
        },
      ],
    };
  },
]);
